import {
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import { ProjectTimeApprovalExtended } from "@repo/server-api/types";
import { useTranslation } from "next-i18next";
import React, { useMemo } from "react";

const DialogShowDescription = (
	props: Readonly<{
		open: boolean;
		setOpen: (value: boolean) => void;
		item: ProjectTimeApprovalExtended | null;
	}>,
) => {
	const { t } = useTranslation();

	const description = useMemo(
		() => props.item?.description ?? "",
		[props.item],
	);

	const open = useMemo(() => {
		return props.open;
	}, [props.open]);

	const handleClose = () => {
		props.setOpen(false);
	};

	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		event.stopPropagation();

		handleClose();
	};

	return (
		<div>
			<Dialog
				open={open}
				PaperProps={{
					component: "form",
					onSubmit: handleSubmit,
				}}
				maxWidth="md"
				fullWidth={true}
			>
				<DialogTitle>{t("no-description")}</DialogTitle>
				<DialogContent className="flex-col gap-5">
					<Box>
						<TextField
							className="w-100"
							label={t("no-description")}
							value={description}
							variant="outlined"
							InputProps={{
								readOnly: true,
							}}
							minRows={1}
							fullWidth
							multiline
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button
						type="submit"
						variant="contained"
						className="blueButton"
					>
						{t("ok")}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default DialogShowDescription;
